module.exports = __webpack_public_path__ + "static/img/th.18046547.svg";